var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeSection33(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.922,
    height: 108.635,
    viewBox: "0 0 65.922 108.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7129",
    "data-name": "Rectangle 7129",
    width: 65.922,
    height: 108.635,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9206",
    "data-name": "Group 9206",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9001",
    "data-name": "Group 9001",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13395",
    "data-name": "Path 13395",
    d: "M13.836,28.261H8.431A3.669,3.669,0,0,1,4.768,24.6V21.645a3.666,3.666,0,0,1,3.663-3.663h5.406A3.667,3.667,0,0,1,17.5,21.645V24.6a3.669,3.669,0,0,1-3.665,3.665M8.431,19.97a1.677,1.677,0,0,0-1.674,1.674V24.6A1.677,1.677,0,0,0,8.431,26.27h5.406A1.675,1.675,0,0,0,15.511,24.6V21.645a1.675,1.675,0,0,0-1.674-1.674Z",
    transform: "translate(7.805 29.435)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13396",
    "data-name": "Path 13396",
    d: "M19.894,28.261H14.488A3.671,3.671,0,0,1,10.823,24.6V21.645a3.669,3.669,0,0,1,3.665-3.663h5.406a3.669,3.669,0,0,1,3.665,3.663V24.6a3.671,3.671,0,0,1-3.665,3.665m-5.406-8.29a1.677,1.677,0,0,0-1.674,1.674V24.6a1.677,1.677,0,0,0,1.674,1.674h5.406A1.675,1.675,0,0,0,21.568,24.6V21.645a1.675,1.675,0,0,0-1.674-1.674Z",
    transform: "translate(17.716 29.435)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13397",
    "data-name": "Path 13397",
    d: "M25.95,28.261H20.544A3.671,3.671,0,0,1,16.879,24.6V21.645a3.669,3.669,0,0,1,3.665-3.663H25.95a3.669,3.669,0,0,1,3.665,3.663V24.6a3.671,3.671,0,0,1-3.665,3.665m-5.406-8.29a1.677,1.677,0,0,0-1.674,1.674V24.6a1.677,1.677,0,0,0,1.674,1.674H25.95A1.677,1.677,0,0,0,27.624,24.6V21.645A1.677,1.677,0,0,0,25.95,19.97Z",
    transform: "translate(27.629 29.435)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13398",
    "data-name": "Path 13398",
    d: "M13.836,33.679H8.431a3.666,3.666,0,0,1-3.663-3.663V27.066A3.666,3.666,0,0,1,8.431,23.4h5.406A3.667,3.667,0,0,1,17.5,27.066v2.951a3.667,3.667,0,0,1-3.665,3.663m-5.406-8.29a1.679,1.679,0,0,0-1.674,1.677v2.951a1.676,1.676,0,0,0,1.674,1.672h5.406a1.675,1.675,0,0,0,1.674-1.672V27.066a1.677,1.677,0,0,0-1.674-1.677Z",
    transform: "translate(7.805 38.309)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13399",
    "data-name": "Path 13399",
    d: "M19.894,33.679H14.488a3.669,3.669,0,0,1-3.665-3.663V27.066A3.669,3.669,0,0,1,14.488,23.4h5.406a3.669,3.669,0,0,1,3.665,3.663v2.951a3.669,3.669,0,0,1-3.665,3.663m-5.406-8.29a1.679,1.679,0,0,0-1.674,1.677v2.951a1.676,1.676,0,0,0,1.674,1.672h5.406a1.675,1.675,0,0,0,1.674-1.672V27.066a1.677,1.677,0,0,0-1.674-1.677Z",
    transform: "translate(17.716 38.309)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13400",
    "data-name": "Path 13400",
    d: "M25.95,33.679H20.544a3.669,3.669,0,0,1-3.665-3.663V27.066A3.669,3.669,0,0,1,20.544,23.4H25.95a3.669,3.669,0,0,1,3.665,3.663v2.951a3.669,3.669,0,0,1-3.665,3.663m-5.406-8.29a1.679,1.679,0,0,0-1.674,1.677v2.951a1.676,1.676,0,0,0,1.674,1.672H25.95a1.676,1.676,0,0,0,1.674-1.672V27.066a1.679,1.679,0,0,0-1.674-1.677Z",
    transform: "translate(27.629 38.309)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13401",
    "data-name": "Path 13401",
    d: "M13.836,39.1H8.431a3.666,3.666,0,0,1-3.663-3.663V32.486a3.666,3.666,0,0,1,3.663-3.663h5.406A3.667,3.667,0,0,1,17.5,32.486v2.951A3.667,3.667,0,0,1,13.836,39.1M8.431,30.811a1.677,1.677,0,0,0-1.674,1.674v2.951a1.677,1.677,0,0,0,1.674,1.674h5.406a1.675,1.675,0,0,0,1.674-1.674V32.486a1.675,1.675,0,0,0-1.674-1.674Z",
    transform: "translate(7.805 47.181)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13402",
    "data-name": "Path 13402",
    d: "M19.894,39.1H14.488a3.669,3.669,0,0,1-3.665-3.663V32.486a3.669,3.669,0,0,1,3.665-3.663h5.406a3.669,3.669,0,0,1,3.665,3.663v2.951A3.669,3.669,0,0,1,19.894,39.1m-5.406-8.288a1.677,1.677,0,0,0-1.674,1.674v2.951a1.677,1.677,0,0,0,1.674,1.674h5.406a1.675,1.675,0,0,0,1.674-1.674V32.486a1.675,1.675,0,0,0-1.674-1.674Z",
    transform: "translate(17.716 47.181)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13403",
    "data-name": "Path 13403",
    d: "M25.95,39.1H20.544a3.669,3.669,0,0,1-3.665-3.663V32.486a3.669,3.669,0,0,1,3.665-3.663H25.95a3.669,3.669,0,0,1,3.665,3.663v2.951A3.669,3.669,0,0,1,25.95,39.1m-5.406-8.288a1.677,1.677,0,0,0-1.674,1.674v2.951a1.677,1.677,0,0,0,1.674,1.674H25.95a1.677,1.677,0,0,0,1.674-1.674V32.486a1.677,1.677,0,0,0-1.674-1.674Z",
    transform: "translate(27.629 47.181)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13404",
    "data-name": "Path 13404",
    d: "M45.774,30.96H8.431A3.667,3.667,0,0,1,4.768,27.3V11.7A3.669,3.669,0,0,1,8.431,8.03H45.774A3.669,3.669,0,0,1,49.437,11.7V27.3a3.667,3.667,0,0,1-3.663,3.665M8.431,10.021A1.677,1.677,0,0,0,6.756,11.7V27.3A1.675,1.675,0,0,0,8.431,28.97H45.774A1.675,1.675,0,0,0,47.449,27.3V11.7a1.677,1.677,0,0,0-1.674-1.674Z",
    transform: "translate(7.805 13.145)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13405",
    "data-name": "Path 13405",
    d: "M49.8,8.186H5.444a1,1,0,0,1,0-1.991H49.8a1,1,0,0,1,0,1.991",
    transform: "translate(7.284 10.141)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13406",
    "data-name": "Path 13406",
    d: "M49.651,108.635H10.506a5.381,5.381,0,0,1-5.184-3.966L4.515,101.7A44.735,44.735,0,0,1,2.949,89.971V23.479a76.531,76.531,0,0,1,.883-11.568L4.9,4.971A5.826,5.826,0,0,1,10.691,0H49.469A5.828,5.828,0,0,1,55.26,4.971l1.065,6.94a76.531,76.531,0,0,1,.883,11.568V89.971A44.747,44.747,0,0,1,55.645,101.7l-.807,2.969a5.382,5.382,0,0,1-5.187,3.966M10.691,1.991A3.849,3.849,0,0,0,6.865,5.274L5.8,12.214a74.6,74.6,0,0,0-.86,11.265V89.971a42.823,42.823,0,0,0,1.5,11.209l.807,2.967a3.387,3.387,0,0,0,3.264,2.5H49.651a3.392,3.392,0,0,0,3.267-2.5l.807-2.967a42.823,42.823,0,0,0,1.5-11.209V23.479a74.235,74.235,0,0,0-.862-11.265l-1.065-6.94a3.844,3.844,0,0,0-3.824-3.283Z",
    transform: "translate(4.827 0.001)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13407",
    "data-name": "Path 13407",
    d: "M25.26,108.632H21.4a.994.994,0,0,1,0-1.988,3.393,3.393,0,0,0,3.267-2.5l.807-2.969a42.791,42.791,0,0,0,1.492-11.209V23.476a74.6,74.6,0,0,0-.857-11.265l-1.068-6.94a3.848,3.848,0,0,0-3.824-3.283.994.994,0,1,1,0-1.988h3.855a5.83,5.83,0,0,1,5.793,4.971l1.065,6.94a76.47,76.47,0,0,1,.883,11.565V89.968A44.74,44.74,0,0,1,31.252,101.7l-.807,2.969a5.38,5.38,0,0,1-5.184,3.963m.411-106.6a5.854,5.854,0,0,1,1.34,2.938l1.068,6.94a76.863,76.863,0,0,1,.881,11.565V89.968A44.737,44.737,0,0,1,27.4,101.7l-.807,2.969a5.352,5.352,0,0,1-1,1.959,3.391,3.391,0,0,0,2.935-2.481l.807-2.969a42.793,42.793,0,0,0,1.5-11.209V23.476a74.6,74.6,0,0,0-.86-11.265L28.9,5.271a3.846,3.846,0,0,0-3.23-3.238",
    transform: "translate(33.105 0.001)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13408",
    "data-name": "Path 13408",
    d: "M12.9,108.632H9.044a5.385,5.385,0,0,1-5.187-3.963L3.051,101.7A44.848,44.848,0,0,1,1.487,89.968V23.476A76.47,76.47,0,0,1,2.37,11.911l1.065-6.94A5.83,5.83,0,0,1,9.229,0h3.855a.994.994,0,1,1,0,1.988A3.851,3.851,0,0,0,9.258,5.271l-1.065,6.94a74.6,74.6,0,0,0-.86,11.265V89.968a42.808,42.808,0,0,0,1.5,11.209l.807,2.969a3.39,3.39,0,0,0,3.264,2.5.994.994,0,1,1,0,1.988M8.633,2.033A3.846,3.846,0,0,0,5.4,5.271l-1.065,6.94a74.233,74.233,0,0,0-.86,11.265V89.968a42.683,42.683,0,0,0,1.5,11.209l.8,2.969a3.4,3.4,0,0,0,2.938,2.481,5.352,5.352,0,0,1-1-1.959L6.908,101.7A44.754,44.754,0,0,1,5.342,89.968V23.476a76.47,76.47,0,0,1,.883-11.565l1.068-6.94a5.854,5.854,0,0,1,1.34-2.938",
    transform: "translate(2.434 0.001)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13409",
    "data-name": "Path 13409",
    d: "M5.574,99.138a4.562,4.562,0,0,1-2.218-.527,3.759,3.759,0,0,1-1.79-2.365A43.82,43.82,0,0,1,0,84.509V18.014A97.905,97.905,0,0,1,.878,6.481,3.434,3.434,0,0,1,3.322,3.4c.6-.132,2.128-.219,3.381,1.817A.995.995,0,1,1,5.01,6.256c-.406-.659-.873-1-1.258-.918a1.512,1.512,0,0,0-.9,1.379,95.751,95.751,0,0,0-.865,11.3V84.509a41.881,41.881,0,0,0,1.492,11.2,1.785,1.785,0,0,0,.833,1.158,3.5,3.5,0,0,0,2.328.142A.995.995,0,0,1,7.2,98.92a6.083,6.083,0,0,1-1.63.219",
    transform: "translate(0 5.463)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13410",
    "data-name": "Path 13410",
    d: "M44.8,40.19H6.617a1,1,0,1,1,0-1.991H44.8a1,1,0,0,1,0,1.991",
    transform: "translate(9.199 62.528)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13411",
    "data-name": "Path 13411",
    d: "M50.561,37.944H5.335a.994.994,0,1,1,0-1.988H50.561a.994.994,0,1,1,0,1.988",
    transform: "translate(7.106 58.857)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13412",
    "data-name": "Path 13412",
    d: "M8.973,14.638l.757.293a2.1,2.1,0,0,1-.591,1.158,1.461,1.461,0,0,1-1.013.364,1.5,1.5,0,0,1-1.226-.58,2.814,2.814,0,0,1-.541-1.817A2.947,2.947,0,0,1,6.9,12.167a1.547,1.547,0,0,1,1.274-.593,1.476,1.476,0,0,1,1.089.446,1.926,1.926,0,0,1,.456.933l-.773.227a1.023,1.023,0,0,0-.293-.585.749.749,0,0,0-.522-.208.824.824,0,0,0-.7.377,2.151,2.151,0,0,0-.274,1.231,2.3,2.3,0,0,0,.266,1.268.8.8,0,0,0,.686.377.713.713,0,0,0,.535-.24,1.509,1.509,0,0,0,.324-.762",
    transform: "translate(10.411 18.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13413",
    "data-name": "Path 13413",
    d: "M11.766,16.322h-.846l-.34-1.068H9.031L8.71,16.322H7.879L9.387,11.6h.825Zm-1.437-1.867L9.793,12.7l-.522,1.751Z",
    transform: "translate(12.897 18.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13414",
    "data-name": "Path 13414",
    d: "M9.649,16.323V11.605h.759l1.585,3.148V11.605h.728v4.717h-.786l-1.558-3.077v3.077Z",
    transform: "translate(15.794 18.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13415",
    "data-name": "Path 13415",
    d: "M13.824,14.638l.757.293a2.1,2.1,0,0,1-.591,1.158,1.461,1.461,0,0,1-1.013.364,1.5,1.5,0,0,1-1.226-.58,2.814,2.814,0,0,1-.541-1.817,2.947,2.947,0,0,1,.543-1.888,1.547,1.547,0,0,1,1.274-.593,1.476,1.476,0,0,1,1.089.446,1.926,1.926,0,0,1,.456.933l-.773.227a1.023,1.023,0,0,0-.293-.585.749.749,0,0,0-.522-.208.824.824,0,0,0-.7.377,2.151,2.151,0,0,0-.274,1.231,2.3,2.3,0,0,0,.266,1.268.8.8,0,0,0,.686.377.713.713,0,0,0,.535-.24,1.509,1.509,0,0,0,.324-.762",
    transform: "translate(18.351 18.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13416",
    "data-name": "Path 13416",
    d: "M12.88,16.323V11.605h2.872v.8H13.658v1.044H15.6v.794H13.658v1.282h2.162v.8Z",
    transform: "translate(21.084 18.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13417",
    "data-name": "Path 13417",
    d: "M14.392,16.3v-4.68h.781V15.5h1.943v.8Z",
    transform: "translate(23.559 19.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13418",
    "data-name": "Path 13418",
    d: "M15.783,16.3v-4.68h.781V15.5h1.943v.8Z",
    transform: "translate(25.835 19.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13419",
    "data-name": "Path 13419",
    d: "M17.166,16.323V11.605h2.872v.8H17.943v1.044h1.943v.794H17.943v1.282h2.162v.8Z",
    transform: "translate(28.098 18.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13420",
    "data-name": "Path 13420",
    d: "M18.666,11.6H20.09a2.166,2.166,0,0,1,.817.119,1.407,1.407,0,0,1,.506.406,2.1,2.1,0,0,1,.364.746,4.2,4.2,0,0,1,.132,1.134,3.668,3.668,0,0,1-.14,1.068,2.125,2.125,0,0,1-.351.715,1.362,1.362,0,0,1-.512.4,1.91,1.91,0,0,1-.773.132H18.666Zm.781.8v3.122h.585a1.523,1.523,0,0,0,.546-.071.641.641,0,0,0,.277-.216,1.188,1.188,0,0,0,.179-.451,3.9,3.9,0,0,0,.071-.812,3.746,3.746,0,0,0-.074-.828,1.106,1.106,0,0,0-.224-.475.706.706,0,0,0-.372-.227A3.02,3.02,0,0,0,19.8,12.4Z",
    transform: "translate(30.554 18.997)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSection33);
export default __webpack_public_path__ + "static/media/home_section_3_3.33442a038d34bab4847f0903dae4746c.svg";
export { ForwardRef as ReactComponent };